import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MessengerSourceRelatedObjectsQueryVariables = Types.Exact<{
  sourceId: Types.Scalars['ID']['input'];
  sourceType: Types.Scalars['String']['input'];
}>;


export type MessengerSourceRelatedObjectsQuery = { __typename?: 'Query', messengerSourceRelatedObjects?: { __typename?: 'SourceRelatedObjects', person?: { __typename?: 'Person', id: number, locale?: string | null, organizationId?: string | null } | null, provider?: { __typename?: 'Provider', id: number, locale?: string | null, primaryContactId?: number | null } | null } | null };


export const MessengerSourceRelatedObjectsDocument = gql`
    query messengerSourceRelatedObjects($sourceId: ID!, $sourceType: String!) {
  messengerSourceRelatedObjects(sourceId: $sourceId, sourceType: $sourceType) {
    person {
      id
      locale
      organizationId
    }
    provider {
      id
      locale
      primaryContactId
    }
  }
}
    `;

/**
 * __useMessengerSourceRelatedObjectsQuery__
 *
 * To run a query within a React component, call `useMessengerSourceRelatedObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessengerSourceRelatedObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessengerSourceRelatedObjectsQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useMessengerSourceRelatedObjectsQuery(baseOptions: Apollo.QueryHookOptions<MessengerSourceRelatedObjectsQuery, MessengerSourceRelatedObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessengerSourceRelatedObjectsQuery, MessengerSourceRelatedObjectsQueryVariables>(MessengerSourceRelatedObjectsDocument, options);
      }
export function useMessengerSourceRelatedObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessengerSourceRelatedObjectsQuery, MessengerSourceRelatedObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessengerSourceRelatedObjectsQuery, MessengerSourceRelatedObjectsQueryVariables>(MessengerSourceRelatedObjectsDocument, options);
        }
export function useMessengerSourceRelatedObjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MessengerSourceRelatedObjectsQuery, MessengerSourceRelatedObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessengerSourceRelatedObjectsQuery, MessengerSourceRelatedObjectsQueryVariables>(MessengerSourceRelatedObjectsDocument, options);
        }
export type MessengerSourceRelatedObjectsQueryHookResult = ReturnType<typeof useMessengerSourceRelatedObjectsQuery>;
export type MessengerSourceRelatedObjectsLazyQueryHookResult = ReturnType<typeof useMessengerSourceRelatedObjectsLazyQuery>;
export type MessengerSourceRelatedObjectsSuspenseQueryHookResult = ReturnType<typeof useMessengerSourceRelatedObjectsSuspenseQuery>;
export type MessengerSourceRelatedObjectsQueryResult = Apollo.QueryResult<MessengerSourceRelatedObjectsQuery, MessengerSourceRelatedObjectsQueryVariables>;